/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';
import { useState } from 'react';

import { PromoBarModule } from '@coursera-web/cds-labs';
import type { BannerColors, Cta, TextLayoutOptions } from '@coursera-web/cds-labs';

import type { PromoTemplatePromoBarFragment } from 'bundles/promo-template/__generated__/contentfulTypes';

type Props = {
  content: PromoTemplatePromoBarFragment;
};

function PromoBarModuleRenderer({ content }: Props) {
  const {
    headline,
    description,
    textLayout,
    backgroundColor,
    bannerColor,
    centerContent,
    primaryCtaText,
    primaryCtaTarget,
    hideBackgroundImages,
  } = content;

  const [isDismissed, setIsDismissed] = useState<boolean>(false);
  const handleDismiss = () => {
    setIsDismissed(true);
  };

  let cta: Cta;
  if (primaryCtaText && primaryCtaTarget) {
    cta = {
      text: primaryCtaText,
      href: primaryCtaTarget,
    };
  }

  const mapProps = () => ({
    headline: headline ?? '',
    description: description ?? '',
    textLayout: textLayout as TextLayoutOptions,
    backgroundColor: backgroundColor ?? 'white',
    centerContent: !!centerContent,
    bannerColor: bannerColor as BannerColors,
    isDismissed,
    onDismiss: handleDismiss,
    cta,
    hideBackgroundImages,
  });

  return <PromoBarModule {...mapProps()} />;
}

export { PromoBarModuleRenderer };

export type { Props };

export default PromoBarModuleRenderer;
